import {useEffect, useState} from "react";
import useAlert from "../useAlert";
import {useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";

export function useCrudForm(repository, {id, onSuccess, onLoad, onBeforeSave, onBeforeLoad}) {

    const {showSuccess, showError} = useAlert();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const {t} = useTranslation();

	const form = useForm({});

	const {  handleSubmit,  errors, setValue, setError } = form;

	const onSubmit = async data => {

	    if (errors.length > 0) {
	        return false;
		}

        try {
	        setIsSubmitting(true);
            if (id) {
                data.id = id;
            }

            if (onBeforeSave) {
                data = onBeforeSave(data);
            }

            const response = await repository.save(data);

	        showSuccess(t('Data has been successfully saved'));
            onSuccess();
        } catch (error) {
	        showError(t('Form contains errors'));

	        if (error) {
                error.forEach(item => {
                    if (item.Code) {
                        setError(item.Code, { message: t('ERROR_' + item.Message) });
                    }
                });
	        }  
            
        } finally {
	        setIsSubmitting(false);
        }
	 }

	 useEffect(async () => {

	     if (id == 'new') {
	         if (onLoad) {
	            onLoad(null);
             }
	         return;
         }

	     try {
	        setIsSubmitting(true);

	        console.log('id = ' + id);
	        const response = await repository.getById(id);

	        let data = response.data;

	        if (onBeforeLoad) {
	            data = onBeforeLoad(data);
            }

	        for (let key in data) {
                 if (data[key] != null) {
                    setValue(key, data[key]);
                 }
	        }

	        if (onLoad) {
	            onLoad(data);
	        }
         } catch (e) {
	         // error
             showError(e.text);
         } finally {
	        setIsSubmitting(false);
         }

	     return () => {

         };
     }, [id]);

	const hasError = (name) => {
	    return errors[name] ? true : false;
    }

	const errorMessage = (name) => {
	    return errors[name] ? errors[name].message : null;
    }

    return {
	    form: form,
        onSubmit: handleSubmit(onSubmit),
        isSubmitting: isSubmitting,
        hasError: hasError,
        errorMessage: errorMessage
	};
}


